// src/pages/Officers.js
import React from "react";

export default function Officers() {
  const styles = {
    page: {
      padding: "20px",
      fontFamily: "'Noto Sans Devanagari', sans-serif",
      background: "#f4f4f9",
    },
    title: {
      textAlign: "center",
      fontSize: "32px",
      fontWeight: "bold",
      color: "#4A148C",
      marginBottom: "30px",
    },
    section: {
      background: "white",
      marginBottom: "25px",
      padding: "15px",
      borderRadius: "10px",
      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
    },
    sectionTitle: {
      fontSize: "22px",
      fontWeight: "bold",
      marginBottom: "12px",
      borderBottom: "2px solid #4A148C",
      display: "inline-block",
      paddingBottom: "4px",
    },
    imgCenter: {
      display: "block",
      margin: "15px auto",
      width: "180px",
      height: "180px",
      objectFit: "cover",
      borderRadius: "50%",
      border: "4px solid #4A148C",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "10px",
    },
    th: {
      background: "#4A148C",
      color: "white",
      padding: "10px",
      border: "1px solid #ddd",
      fontSize: "16px",
    },
    td: {
      padding: "10px",
      border: "1px solid #ddd",
      fontSize: "16px",
    },
  };

  const officersData = [
    {
      section: "गट विकास अधिकारी",
      image: "/images/gatvikas.jpeg", // **फोटोचा पाथ**
      members: [
        ["श्री धनंजय साळवे", "गट विकास अधिकारी"],
        ["श्री श्री नितीन फुलझेले ", "सहाय. गट विकास अधिकारी"],
      ],
    },

    {
      section: "आस्थापना विभाग",
      members: [
        ["श्री आनंद सातपुते", "सहायक प्रशासन अधिकारी"],
        ["सौ. सरिता गणेश उरकुडे", "कनिष्ठ प्रशासनिक अधिकारी"],
        [" श्री. पवन बंडु कन्नाके", "वितरक अधिकारी (सा.)"],
        [" श्री. शंकर बबन जुनघरे ", "कनिष्ठ सहाय्यक (लि.व.)"],
        [" श्री.सुरज नरहरी मेश्राम ", "कनिष्ठ सहाय्यक  (लि.व.)"],
        [" श्री. अकुंश महेश मानकर ", "कनिष्ठ सहाय्यक  (लि.व.)"],
        [" श्री. लक्ष्मीकांत जनार्धन जांभुळे ", "कनिष्ठ सहाय्यक  (लि.व.)"],
      ],
    },

    {
      section: "पंचायत विभाग",
      members: [
        ["श्री.दिलीप बाबुराव बैलनवार ", "विस्तार अधिकारी (प.)"],
        ["श्री. सुभाष सोमेश्वर आडेपवार", "जेप्ठ सहा. "],
        ["श्री. अजय आनंदराव चिकटे", "कनिष्ठ सहा."],
        ["कु. रिना रमेश वासेकर", "तालुका व्यवस्थापक"],
        ["सौ. उषा रत्नाकर निब्रड", "डेटा एंट्री ऑपरेटर"],
      ],
    },

    {
      section: "लेखा विभाग",
      members: [
        ["सौ. स्वाती योगेश कुलकर्णी", "सहाय. लेखाधिकारी"],
        ["श्री. मेल्वीन दिपक रायपुरे ", "कनिष्ठ लेखाधिकारी"],
        ["श्री. स्वप्नील नदकुमार आदेवार ", "ज्येष्ठ सहाय्यक (लेखा)"],
        ["श्री. सचिन अरविंद हिराणी ", "ज्येष्ठ सहाय्यक (लेखा)"],
        ["कु.रिजवाना अ. शेंख ", "डेटा एंट्री ऑपरेटर"],
      ],
    },

    {
      section: "पशुसंवर्धन विभाग ",
      members: [
        ["श्री. प्रविण पंडीतराव पिदुरकार ", "प्रभारी पशुधन विकास अधिकारी"],
        ["श्री. सुनिल परशुराव अलाम ", "सहा. पशुधन विकास अधिकारी"],
        ["कु. सोनाली यंशवत मेश्राम", "पशुधन पर्यवेक्षक"],
        ["श्री. अशोक लक्ष्मण क्षीरसागर", "व्रणोपचारक"],
      ],
    },

    {
      section: "आरोग्य विभाग",
      members: [["श्री. साहेबराव व्यंकटी पवार", "आरोग्य पर्यवेक्षक (वि.)"]],
    },

    {
      section: "म.रा.रो.हमी योजना",
      members: [
        ["श्री. रविकुमार बोगावार", "सहा. कार्यक्रम अधिकारी"],
        ["श्री. राजेश डी.बटटे", "पॅनल तांत्रिक अधिकारी"],
        ["श्री. सोनु बी. शिध्देवार", "डेटा एंट्री ऑपरेटर"],
        ["कु. श्रुती जी खरतड", "डेटा एंट्री ऑपरेटर"],
        ["कु. श्वेता रमेश पिपरे", "तांत्रिक सहाय्यक"],
      ],
    },

    {
      section: "ए.बा.वि.से.यो प्रकल्प",
      members: [
        ["कु. शुंभागी व-हाटे ", "[प्रभारी बा.वि.अ]"],
        ["कु. शुंभागी व-हाटे ", "विस्तार अधिकारी (सा.)"],
        ["श्रीमती योगिता पेटकुळे", "कनिष्ठ सहा."],
      ],
    },

    {
      section: "कृषी विभाग",
      members: [
        ["श्री. नितीन केशवराव ढवस", "प्र. कृषी अधिकारी"],
        ["श्री. नितीन केशवराव ढवस", "विस्तार अधिकारी (कृ)"],
        ["श्री. विवेक शेरखात उमरे", "विस्तार अधिकारी (कृ)"],
      ],
    },

    {
      section: "शिक्षण विभाग",
      members: [
        ["श्री. सचिनकुमार जयराम मालवी", "प्रभारी"],
        ["सौ. मेघा दिगांबर बल्की", "कनिष्ठ प्रशासन अधिकारी"],
        ["श्री. नरेन्द्र कुमरे", "केंद्रप्रमुख"],
        ["सौ.किरण कामडी", "केंद्रप्रमुख"],
        ["सौ. सबतकौर भौंड", "केंद्रप्रमुख"],
        ["श्री. विकास रघुनाथ भगरत", "ज्येष्ठ सहाय्यक (नि. अ.)"],
        ["श्री. कमलाकर सुदाम खोब्रागडेे", "कनिष्ठ सहा."],
        ["श्री. पवनकुमार किशन चव्हान", "कनिष्ठ सहा."],
        ["सौ.गिता राजेंद्र आईटलावार", "कनिष्ठ सहा."],
      ],
    },

    {
      section: "बांधकाम विभाग ",
      members: [
        ["श्री.रविद्रं बाळक्रिष्णा चंदनखेडे", "कनिष्ठ अभियंता"],
        ["कु. थामेश्वरी अरुन ठाकरे", "कनिष्ठ अभियंता"],
        ["श्री. प्रविण को. रतनवार ", "कनिष्ठ आरेखक"],
      ],
    },

    {
      section: "स्वच्छ भारत मिशन",
      members: [
        ["श्री. सुनिल नुत्तलवार", "समुह समन्वयक"],
        ["श्री. अनिकेत एम.बोमकंटीवार", "सहाय्यक सल्लागार"],
      ],
    },

    {
      section: "घरकुल ",
      members: [
        ["श्री. प्रमोद शास्त्रकार ", "ग्रा.गृहनिर्माण अभियंता"],
        ["श्री. प्रशांत गणविर", "ग्रा.गृहनिर्माण अभियंता"],
        ["कु. पल्लवी पराते  ", "डाटा ऐंट्री ऑपरेटर"],
      ],
    },
  ];

  return (
    <div style={styles.page}>
      <h1 style={styles.title}>अधिकारी माहिती</h1>

      {officersData.map((section, index) => (
        <div key={index} style={styles.section}>
          <div style={styles.sectionTitle}>{section.section}</div>

          {/* जर फोटो असेल तर तो center मध्ये दाखवा */}
          {section.image && (
            <img
              src={section.image}
              alt={section.section}
              style={styles.imgCenter}
            />
          )}

          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>नाव</th>
                <th style={styles.th}>पद</th>
              </tr>
            </thead>

            <tbody>
              {section.members.map((m, i) => (
                <tr key={i}>
                  <td style={styles.td}>{m[0]}</td>
                  <td style={styles.td}>{m[1]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}
